export default {

  stocks: `
  query stocks($forStocks: [ID]) {
    stocks(forStocks: $forStocks) {
  edges{
    node{
      price
      salePrice
      referenceName
      settlementPrice
    }
  }
    }}
`,

  storecategories:`
  query store($storeId: ID!) {
    store(id: $storeId) {
      id
      name
      image
      address
      isOpen
      phones
      maxDepth
      businessDomain {
        id
        image
      }
      categories(level: 0) {
        edges {
          node {
            id
            name
            level
            depth
            image
            children {
              edges {
                node {
                  id
                  name
                  level
                  depth
                  image
                  children{
                    edges{
                      node{
                        id
                        name
                        level
                        depth
                        image
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`,
//test
getstoreDeliverySlot:`
query gtstoreDeliverySlot($storeId:ID){
  getstoreDeliverySlot:storeDeliverySlot(store:$storeId, status:"ACTIVE"){
    edges{
      node{
        id
        store{
          id
          name
          fetchCutomerDetails
        }
        deliveryType
        startTime
        endTime
        capacity
        deliveryduration
        orderCutoff          
      }
    }
  }
}`
 ,



 getProductSKUsStocksForCategory:`
 query getProductSKUsStocksForCategory($categoryId: ID!, $storeId: ID!, $after: String!) {
  products(forCategory: $categoryId, first:20, after: $after, forStore: $storeId ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        name
        id
        image
        description
        contains
        selectedColor
        fontColor
        category {
          id
          name
        }
        mask
        skus {
          edges {
            node {
              name
              quantity
              id
              maximumRetailPrice
              maximumRetailPriceCurrency
              selectedColor
              defaultSelected
              image
              stocks(forStore: $storeId) {
                edges {
                  node {
                    id
                    inStock
                    stockText
                    price
                    salePrice
                    salePriceCurrency
                    store {
                      id
                      name
                      fetchCutomerDetails
                      pickupPoints {
                        edges {
                          node {
                            id
                            name
                          }
                        }
                      }
                    }
                    customizations(level: 0) {
                      edges {
                        node {
                          id
                          name
                          level
                          maxSelectable
                          minSelectable
                          children {
                            edges {
                              node {
                                id
                                defaultSelected
                                name
                                price
                                priceCurrency
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}`,

pendingDelivery:`
  query getPeindingDeliveryOrder($storeId:ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime, $merchantId:ID){
    pendingDelivery: orders(status_In:"PENDINGDISPATCHED, DISPATCHED, ATDELIVERYPOINT",forStore:$storeId,createdAt_Gte:$createdAt_Gte,createdAt_Lte:$createdAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          thirdpartyDelivery
          trackingUrl
          trackingToken
          thirdpartyDeliveryurl
          thirdpartyDeliverycompany
          thirdpartyDeliverydescription
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }
          delivery{
            id
            userProfile{
              firstName
              lastName
            }
          }
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            settlementExtra
            subtotal
            total
            totalCurrency
            deliverySlot
            cartItems {
              edges {
                node {
                  id
                  quantity
                  status
                  stock{
                    sku{
                      id
                      name
                    }
                  }
                }
              }
            }
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              
              store{
                name
                localDelivery
                thirdpartyDelivery
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`,
  getAccountdetails:`
  query store($storeId: ID!) {
    store(id: $storeId) {
      id
      name
      image
      address
      isOpen
      phones
      maxDepth
      accountNo
      accountName
      accountVerified
      ifsccode
      gstNo
      businessDomain {
        id
        image
        templateStoreId
      }
      
    }
  }
  `,
  getUserProfile: `
  query{
    userProfile {
      user {
        id
        store {
          id
          name
          emails
          email
          phones
          address
          image
          area
          city
          postalCode
          latitude
          longitude
          isOpen
          delivery
          referenceStoreCode
          teststore
          isMultiplePrintEnabled
          isPrintEnabled
          isSosApiCall
          isPrintStoreName
          isPrintRegionName
          isPrintCustomerName
          isPrintPickupPointName
          isPrintCustomerPhoneNumber
          canAutoPrintKot
          shouldPrintViaApp
          showNew
          showPush
          showReady
          showApproaching
          showArrived
          showPromoting
          showImageApproved
          showDeliveryPersons
          showDpLocationTracking
          showHubQrcode
          showHolidayCalendar
          showDeliverySchedule
          barCodeGenerate
          printSdkType
          canMarkOpen
          canMarkReady
          canScanQrcode
          canMarkAccept
          canMarkReject
          canMarkCouldReject
          canMarkRejectRequest
          canMarkDeliver
          canMarkNotDelivered
          printRollChange
          customUrl
          accountName
          accountVerified
          accountNo
          gstNo
          ifsccode
          fetchCutomerDetails
          chromePrinters
          fetchPrinterInfo
          onePosMultiStore
          foodcourtCashier
          pickupPoints{
            edges{
              node{
                latitude
                longitude
              }
            }
          }
          region{
            id
            name
          }
          businessDomain {
            id
            name
            templateStoreId

          }
        }
        concessionaire{
          edges{
            node{
              name
              id
              
            }
          }
        }
        merchant {
          id
          name
          image
          stores{
            edges{
              node{
                name
                id
              }
            }
          }
        }
      }
    }
  }
  `,
  checkStoreCustomUrl: ` query stores($customUrl:String){
    stores(customUrl:$customUrl) {
      edges{
        node{
          id
          customUrl
        }
      }
    }
  }`,

  CREATE_STOCK:`mutation updateStock($input: StockInput!) {
      updateStock(input: $input) {
        success
        stock {
          id
          store{
            id
            name
            fetchCutomerDetails
            pickupPoints{
              edges{
                node{
                  id
                }
              }
            }
          }
        }
      }
    }
  `,

  GET_STOCK_FOR_SKU: `query getStocksForSkus($skuId: [ID], $storeId: ID!) {
    stocks(forSkus:$skuId, store:$storeId){
      edges{
        node{
          id
          inStock
          price
          salePriceCurrency
          salePrice
          store{
            id
            fetchCutomerDetails
            pickupPoints{
              edges{
                node{
                  id
                }
              }
            }
          }
        }
      }
    }     
  }`,
  getUserProfileStaff: `
      query
      {
          userProfile
          {
              id
              firstName
              lastName
              image
              user
              {
                  id
                  phone
                  email
              }
          }
      }
      `,
  getDeliveryPersonLocation: `query{
    userProfile {
      user {
        id
        store {
          id
          name
          fetchCutomerDetails
          hubs {
            edges {
              node {
                id
                name
                latitude
                longitude
                hubDeliveryPersonRef(status: "ACTIVE") {
                  edges {
                    node {
                      id
                      isApprove
                      isMerchantSercurity
                      status
                      deliveryPerson {
                        id
                        user
                        latitude
                        longitude
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
  getUsersByIDs: `
  query users($forUsers:[ID]){
    users(forUsers:$forUsers){
      edges{
        node{
          phone
          userProfile{
            firstName
            lastName
          }
          deliveryPersons{
            edges{
              node{
                id
                
              }
            }
          }
        }
      }
    }
  }`,
  getuserAvailedServices: `
  query getuserAvailedServices($forRegions: [ID]) {
    userAvailedServices(forRegions: $forRegions,isFulfilled:false) {
      edges {
        node {
          id
          isAccepted
          isFulfilled
          location
          user {
            phone
            userProfile {
              firstName
              lastName
            }
          }
          comments
          service {
            id
            status
            name
            region {
              id
              name
            }
          }
        }
      }
    }
  }
  `,
  getBookingOrderDetails: `query getBookingOrderDetails($storeId: ID,$orderBookingDateAt_Gte:DateTime,$orderBookingDateAt_Lte:DateTime){
    orderHistory: orders(status_In:"ACCEPTED,READY,DISPATCHED,DELIVERED, NOTDELIVERED,REJECTED,PICKEDUP",forStore:$storeId,orderBookingDateAt_Gte:$orderBookingDateAt_Gte,orderBookingDateAt_Lte:$orderBookingDateAt_Lte, isTest:false,fetchAll:true){
      totalCount
      edges {
        node {
          id
          storeToken
          customerStatus
          trackingToken
          orderId
          trackingUrl
          status
          pushedAt
          createdAt
          storeRunningBillId
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname        
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }  
          user {
            phone
            userProfile {
              lastName
              firstName
              codeType
              codeVerified
            }
          }
          cart {
            settlementExtra
            settlementPrice
            specialInstructions
            subtotal
            
            cartItems {
              edges {
                node {
                  id
                  quantity
                  settlementPrice
                  settlementPriceCurrency
                  total
                  status
                  customizations {
                    edges {
                      node {
                        name
                        settlementPrice
                        id
                        parent {
                          name
                          settlementPrice
                          id
                        }
                      }
                    }
                  }
                  stock {
                    id
                    referenceId
                    referenceName
                    settlementPrice
                    quantity
                    sku {
                      name
                      description
                      quantity
                      unit
                    }
                  }
                }
              }
            }
            checkout {
              id
              mode
              code
              codeType
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              latitude
              longitude
              sla {
                pushType
                pushValue
                preparationTime
              }
              store {
                name
                phones
                fetchCutomerDetails
                referenceStoreCode
                referenceStorePosCode
              }
            }
          }
        }
      }
    }
  }`,
  getMerchantName: `
    query {
      merchants{
        edges{
          node{
            name
            id
          }
        }
      }
    }    
    `,
  getInventory: `
      query getInventoryStore($storeId:ID!,$referenceName_Icontains:String, $categoryID:ID){
          
          stocks(store:$storeId, categoryId:$categoryID, sortBy:"in_stock",referenceName_Icontains:$referenceName_Icontains){
              pageInfo {
                startCursor
                endCursor
              }
              totalCount
              edges{
                  node{
                      inStock
                      id
                      referenceId
                      referenceName
                      settlementPrice
                      settlementPriceCurrency
                    	locallngName
                      locallngDescription
                    	salePrice
                    	price
                    	isMrpItem
                      sku{
                          id
                          name
                          image
                          description
                          maximumRetailPrice
                          maximumRetailPriceCurrency
                          locallngName
                          locallngDescription
                          quantity
                          unit
                          product{
                              name
                              id
                              image
                              imageApproved
                              imageSource
                              description
                              locallngName
                              locallngDescription
                              category{
                                name
                              }
                          }
                      }
                  }
              }
          }
      }
  `,
  getOrders: `
  query getOrders($storeId: ID, $merchantId: ID, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime) {
    orderHistory: orders(status_In: "DELIVERED,NOTDELIVERED,DISPATCHED,REJECTED,PICKEDUP", forStore: $storeId, createdAt_Gte: $createdAt_Gte, createdAt_Lte: $createdAt_Lte, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname       
          support {
             
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }   
          sla
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              total
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store {
                name
                fetchCutomerDetails
              }
            }
          }
        }
      }
    }
    newOrders: orders(status: "PUSHED", forStore: $storeId, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          comments
          status
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname      
          support {
             
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }    
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode

                    status
                    capturedAmount
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
               store {
                name
                fetchCutomerDetails
              }
            }
          }
        }
      }
    }
    acceptedOrders: orders(status_In: "ACCEPTED,READY", customerStatus: "ENROUTE", forStore: $storeId, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname         
          support {
           
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          } 
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount
                    
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
               store {
                name
                fetchCutomerDetails
              }
            }
          }
        }
      }
    }
    approachingOrders: orders(status_In: "ACCEPTED,READY", customerStatus: "APPROACHING", forStore: $storeId, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname   
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }       
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount
                    
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
               store {
                name
                fetchCutomerDetails
              }
            }
          }
        }
      }
    }
    arrivedOrders: orders(status_In: "ACCEPTED,READY", customerStatus: "ARRIVED", forStore: $storeId, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname        
          support {
             
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }  
          invoiceNo
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount
                    
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
               store {
                name
                fetchCutomerDetails
              }
            }
          }
        }
      }
    }
  }
  
  `,
  getConcessionaireOrders: `
  query getConcessionaireOrders($concessionarieId: ID, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime) {
    orderHistory: productConcessionaireOrderSummary(forConcessionaire: $concessionarieId, createDate_Gte: $createdAt_Gte, createDate_Lte: $createdAt_Lte) {
      totalCount
      edges {
        node {
          name
          orderId
          createDate
          storeToken
          comments
          invoiceNo
          storeRunningBillId
          status
          subtotal
          discount
          taxAmount
          totalAmount
        }
      }
    }
  }
  `,
  getKioskOrders: `
  query getOrders($storeId: ID, $merchantId: ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime) {
    orderHistory: orders(status_In: "DELIVERED,NOTDELIVERED,DISPATCHED,REJECTED,PICKEDUP", forStore: $storeId, createdAt_Gte: $createdAt_Gte, createdAt_Lte: $createdAt_Lte, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          comments
          invoiceNo
          status
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname      
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }    
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              total
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount
                    
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store {
                name
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
    newOrders: orders(status: "PUSHED", forStore: $storeId, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          sla
          comments
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store{
                name
                fetchCutomerDetails
                region{
                  name
                }
              }
              
            }
          }
        }
      }
    }
    acceptedOrders: orders(status_In: "ACCEPTED,READY", customerStatus_In: "ENROUTE,APPROACHING,ARRIVED", forStore: $storeId, forMerchant: $merchantId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          status
          orderId
          pushedAt
          createdAt
          comments
          customerStatus
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname     
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }     
          sla
          invoiceNo
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency
                    
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              sla {
                pushType
                pushValue
                preparationTime
              }
              name
              store{
                name
                fetchCutomerDetails
                region
                {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  
  `,
  getOrderDetails: `
  query getOrderDetails($orderId:String) {
    orderDetails: orders(fetchAll: true, orderId: $orderId,isTest:false) {
      totalCount
      edges {
        node {
          id
          storeToken
          customerStatus
          trackingToken
          orderId
          trackingUrl
          status
          pushedAt
          createdAt
          sla
          deliveryEndtime
          comments
          invoiceNo
          storeRunningBillId
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          deliveryPersonFirstName
          deliveryPersonLastName
          deliveryPersonPhone 
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          user {
            phone
            userProfile {
              lastName
              firstName
              codeType
              codeVerified
            }
          }
          cart {
            settlementExtra
            settlementPrice
            settlementPriceCurrency
            specialInstructions
            total
            totalCurrency
            deliverySlot
            deliveryEndtime
            cartItems {
              edges {
                node {
                  id
                  quantity
                  settlementPrice
                  settlementPriceCurrency
                  total
                  status
                  customizations {
                    edges {
                      node {
                        name
                        settlementPriceCurrency
                        settlementPrice
                        id
                        parent {
                          name
                          settlementPriceCurrency
                          settlementPrice
                          id
                        }
                      }
                    }
                  }
                  stock {
                    id
                    referenceId
                    referenceName
                    settlementPrice
                    settlementPriceCurrency
                    taxValue
                    quantity
                    locallngName
                    locallngDescription
                    status
                    salePrice
                    price
                    sku {
                      name
                      description
                      locallngName
                      locallngDescription
                      quantity
                      unit
                      maximumRetailPrice
                    }
                  }
                }
              }
            }
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              total
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              latitude
              longitude
              sla {
                pushType
                pushValue
                preparationTime
              }
              store {
                name
                phones
                stockLevelTax
                taxIncluded
                referenceStoreCode
                referenceStorePosCode
                fetchCutomerDetails
                chromePrinters
                fetchPrinterInfo
                forcePrinterSelection
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }  
  `,
  createStorePerson: `
  mutation createStorePerson($input: CreateStorePersonInput!) {
    createStorePerson(input: $input) {
      success
    }
  }
`,
updateCategoryMerchantStore:`
mutation updateCategoryMerchantStore($input: CategoryMerchantStoreInput! ){
  updateCategoryMerchantStore(input:$input){
     success
  }
}`,

  DeleteStoreDeliverySlot:`
  mutation UpdateStoreDeliverySlot($input: StoreDeliverySlotInput!) {
    updateStoreDeliverySlot(input: $input) {
      success
    }
  }`,

  updateStoreDeliverySlot:`mutation updateStoreDeliverySlot($input: StoreDeliverySlotInput!) {
    updateStoreDeliverySlot(input: $input) {
      success
    }
  }`
,

UpdateCartItemFulfilmentPrice:`mutation UpdateCartItemFulfilmentPrice($input: CartItemPriceUpdateInput!) {
  UpdateCartItemFulfilmentPrice(input: $input) {
    cartItem{
      id
      subtotal
      total
      unitPrice
      
    }
  }
}`
,
  updatePayCounter: `
  mutation updatePayCounter($input: PayAtCounterRequestInput!){
    updatePayCounter(input:$input){
            success    
      }
  }
`,
  updateStock: `
      mutation updateStock($input: StockInput!){
          updateStock(input:$input){
                success    
          }
      }
  `,
  updateSku: `
  mutation updateSku($input: SkuInput!){
    updateSku(input:$input){
            success    
      }
  }
`,
  updateProduct: `
      mutation updateProduct($input: ProductInput!){
        updateProduct(input:$input){
                success    
          }
      }
  `,
  updateOrder: `
  mutation updateOrder($input: OrderInput!){
      updateOrder(input: $input){
        order{
          storeToken
          status
          delivery{
            id
            userProfile{
              firstName
              lastName
            }
          }
          customerStatus
          thirdpartyDeliverycompany
          thirdpartyDeliverydescription
          thirdpartyDeliveryurl
        }
      }
    }
  `,
  updateSOSWaiter: `
  mutation updateSOSWaiter($input: UserAvailedServiceInput!){
    updateUserAvailedService(input: $input){
      success
      }
    }
  `,
  updateFulfillment: `mutation updateFulfillment($input: FulfillmentInput!){
    updateFulfillment(input:$input){
      cartItem{
        status
      }
   }
  }`,
  updateDeliveryPersonHubRef: `
  mutation updateDeliveryPersonHubRef($input: DeliveryPersonHubReferenceInput!) {
    updateDeliveryPersonHubRef(input: $input) {
      success
    }
  }
  `,
  
  getAdvanceOrders: `query getAdvanceOrders($storeId:ID,$pushedAt_Gte:DateTime,$pushedAt_Lte:DateTime, $merchantId:ID){
    orderHistory: orders(status_In:"NEW",forStore:$storeId,pushedAt_Gte:$pushedAt_Gte,pushedAt_Lte:$pushedAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            settlementExtra
            subtotal
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store{
                name
                localDelivery
                thirdpartyDelivery
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }`
  ,

  getOrderHistory: `query getOrderHistory($storeId:ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime, $merchantId:ID){
    orderHistory: orders(status_In:"DELIVERED,NOTDELIVERED,DISPATCHED,REJECTED,PICKEDUP",forStore:$storeId,createdAt_Gte:$createdAt_Gte,createdAt_Lte:$createdAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          pushedAt
          createdAt
          status
          cart {
            settlementPrice
            
            subtotal
            total
            checkout{
              mode
            }
            pickupPoint {
              store{
                name
              }
            }
          }
        }
      }
    }
  }`,
  getOrderRejectRequest: `query getOrderRejectRequest($storeId:ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime, $merchantId:ID){
    orderHistory: orders(status_In:"REJECTREQUEST",forStore:$storeId,createdAt_Gte:$createdAt_Gte,createdAt_Lte:$createdAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            settlementExtra
            subtotal
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store{
                name
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }`,
  getOrderReject: `query getOrderReject($storeId:ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime, $merchantId:ID){
    orderHistory: orders(status_In:"REJECTED",forStore:$storeId,createdAt_Gte:$createdAt_Gte,createdAt_Lte:$createdAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            settlementExtra
            subtotal
            
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store{
                name
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }`,
  getOrderHistoryACCEPTED: `query getOrderHistoryACCEPTED($storeId:ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime, $merchantId:ID){
    orderHistory: orders(status_In:"ACCEPTED,READY,DISPATCHED,DELIVERED,NOTDELIVERED,REJECTED,PICKEDUP",forStore:$storeId,createdAt_Gte:$createdAt_Gte,createdAt_Lte:$createdAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          user {
            phone
            userProfile {
              lastName
              firstName
            }
          }
          cart {
            settlementPrice
            settlementExtra
            subtotal
            
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store{
                name
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }`,
  getOrderHistoryBookingOrders: `query getOrderHistoryBookingOrders($storeId:ID, $merchantId:ID){
    orderHistory: orders(status_In:"DISPATCHED,DELIVERED,NOTDELIVERED,REJECTED,PICKEDUP",forStore:$storeId, forMerchant:$merchantId,isTest:false,isBookingDateNull:true){
      totalCount
      edges {
        node {
          id
          storeToken
          orderId
          customerStatus
          pushedAt
          createdAt
          status
          comments
          sla
          invoiceNo
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname          
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }
          cart {
            settlementPrice
            settlementExtra
            subtotal
            total
            totalCurrency
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              store{
                name
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }`,
  getProducts: `query getProducts ($stockId: ID!) {
    stock(id: $stockId) {
      inStock
      id
      referenceId
      referenceName
      customizations(level: 0, sortBy: "display_order") {
        edges {
          node {
            description
            id
            defaultSelected
            name
            maxSelectable
            minSelectable
            displayOrder
            salePrice
            depth
            children {
              edges {
                node {
                  id
                  defaultSelected
                  maxSelectable
                  salePrice
                  depth
                  name
                  contains
                  minSelectable
                }
              }
            }
            contains
          }
        }
      }
    
    }
  }
  `,
  productCategorySkuStock: `
  query productCategorySkuStock($storeId: ID) {
    productCategorySkuStock(
      forStore: $storeId,  inStock: true ,dinein :true
    ) {
      edges {
        node {
          skuName
          productName
          productImage
          stockSla
          inStock
          stockSalePrice
          quantity
          category
          categoryName
          contains
          product
          stock
          takeaway
          dinein
          delivery
        }
      }
    }
  }`,

  getMerchantOrderDetails: `query getMerchantOrderDetails($storeId:ID,$createdAt_Gte:DateTime,$createdAt_Lte:DateTime, $merchantId:ID){
    orderHistory: orders(status_In:"ACCEPTED,READY,DISPATCHED,DELIVERED,NOTDELIVERED,REJECTED,PICKEDUP",forStore:$storeId,pushedAt_Gte:$createdAt_Gte,pushedAt_Lte:$createdAt_Lte, forMerchant:$merchantId,isTest:false){
      totalCount
      edges {
        node {
          id
          storeToken
          customerStatus
          trackingToken
          orderId
          trackingUrl
          status
          pushedAt
          createdAt
          storeRunningBillId
          
          tempCustomerPhone
          tempCustomerFirstname
          tempCustomerLastname
          support {
            
            userProfile {
              lastName
              firstName
              user{phone}  
            }
          }          
          sla
          invoiceNo
          user {
            phone
            userProfile {
              lastName
              firstName
              codeType
              codeVerified
            }
          }
          cart {
            settlementExtra
            settlementPrice
            specialInstructions
            subtotal
            total
            totalCurrency
            cartItems {
              edges {
                node {
                  id
                  quantity
                  settlementPrice
                  settlementPriceCurrency
                  total
                  status
                  customizations {
                    edges {
                      node {
                        name
                        settlementPrice
                        id
                        parent {
                          name
                          settlementPrice
                          id
                        }
                      }
                    }
                  }
                  stock {
                    id
                    referenceId
                    referenceName
                    settlementPrice
                    quantity
                    locallngName
                    locallngDescription
                    sku {
                      name
                      description
                      quantity
                      locallngName
                      locallngDescription
                      unit
                    }
                  }
                }
              }
            }
            checkout {
              id
              deliveryLocation
              mode
              code
              codeType
              paymentRequests{
                edges{
                  node{
                    id
                    isCompleted
                    createdAt
                  }
                }
              }
              payments{
                edges{
                  node{
                    id
                    mode
                    status
                    capturedAmount 
                    amount
                    amountCurrency  
                  }
                }
              }
              userLocation{
                addressLine1
                addressLine2
                pincode
                city
                name
                house
                landmark	
                latitude
                longitude
              }
              userVehicle {
                type
                model
                registration
              }
            }
            pickupPoint {
              name
              latitude
              longitude
              sla {
                pushType
                pushValue
                preparationTime
              }
              store {
                name
                phones
                referenceStoreCode
                referenceStorePosCode
                fetchCutomerDetails
                region{
                  name
                }
              }
            }
          }
        }
      }
    }
  }`,
  updateUserProfile: `
  mutation updateUserProfile($input: UserProfileInput!){
    updateUserProfile(input:$input)
    {
      error
        userProfile
        {
          id
          firstName

        }
    }
  }`,
  getConcessionaireStores: `
    query {
      stores{
        edges{
          node{
            name
            id
          }
        }
      }
    }    
    `,
  updateStore: `
  mutation updateStore($input: StoreInput!){
    updateStore(input:$input){
        store{
          isOpen
        }
    }
  }`,
  getStores: `
  query getStores($merchantId: ID!){
    merchant(id:$merchantId){
      stores{
        edges{
          node{
            name
            id
          }
        }
      }
    }
  }
  `,
  updateStoreActivator: `
  mutation updateStoreActivator($input:UserInput!){
    updateStorePromoter(input:$input){
      success
    }
  }
  `,
  updateStoreAccountDetails: `
  mutation updateStore($input: StoreInput!){
    updateStore(input:$input){
        store{
          id
        }
    }
  }`,
  updateStoreStatus: `
  mutation updateStore($input: StoreInput!){
    updateStore(input:$input){
        store{
          isOpen
          printRollChange
        }
    }
  }`,
  updatePrinterInformation: `
  mutation updateStore($input: StoreInput!){
    updateStore(input:$input){
        store{
          chromePrinters
          fetchPrinterInfo
        }
    }
  }`,
  updateStoreCalendarHoliday: `
  mutation updateStoreCalendarHoliday($input: StoreCalendarHolidayInput!){
    updateStoreCalendarHoliday(input:$input){
       success
    }
  }`,
  getStoreHolidayCalendar: `query getStoreHolidayCalendar($storeIds:[ID]){
    storeHolidayCalendar(forStores:$storeIds,status:"ACTIVE"){
      edges{
        node{
          id
          holidayDates
          status
        }
      }
    }
  }`,

  getStorePromoters: `
  query getStorePromoters($storeId:ID!){
    storePromoters(forStore:$storeId){
      edges{
        node{
          id
          phone
          userProfile{
            firstName
            lastName
          }
          referralCount
          referralOrderedCount
          referralChildren{
            edges{
              node{
                id
                createdAt
                child{
                  userProfile{
                    firstName
                  }
                }
              }
            }
          }
        }
      }
    }
  }  
  `,


};


// WEBPACK FOOTER //
// ./src/singletons/RequestManager/queries.js